export default __webpack_public_path__ + "static/N0121-7d31dd4d669d2f2a19b89f58eb155ee3.png";